import { places } from "../data/places";
import { toEuro } from "../helpers/formatNumbers";
import { getDisplayedValue } from "../helpers/initialize";
import { sortArrayByObjectField } from "../helpers/sort";

const getSqlFromJs = word => word?.split('')?.map(c => 
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ".includes(c) ? `_${c.toLowerCase()}` : c).join('');

    function filterFalsy(obj) {
        const resultObj = Object.keys(obj).reduce((acc, key) => {
          if (obj[key])acc[key] = obj[key]
          return acc
        }, {});
        return resultObj
      }

const getJsonArr =  values => {
  // console.log({values});
  const jsonArr = [];
  const resArr = values.split('\n');
  const keys = resArr[0].split('\t');
  // console.log({resArr, keys});
  for(let i = 1; i < resArr.length - 1; i++){
    const line = resArr[i];
    const values = line.split('\t');
    const innerObj = {};
    for(let j = 0 ; j < keys.length; j++){
      // console.log(keys[j], values[j]);
        const value = values[j].trim() ? values[j].trim() : null;
        const key = keys[j].trim();
        if(!!value)innerObj[`${key}`] = isNaN(+value) ? value : +value;
    };
    jsonArr.push(filterFalsy(innerObj));
  };
  return jsonArr;
}
const getSql = jsonArr => {
  return jsonArr.map(pl => {
    const {name, sqlType, maxLength, type} = pl;
    const sqlName = getSqlFromJs(name);
    const newSqlType = sqlType ? sqlType 
                        : maxLength ? `VARCHAR(${maxLength})`
                        : type === "integer" ? "INTEGER"
                        : type === "number" ? "INTEGER"
                        : type === "string" ? "TEXT"
                        : type?.toUpperCase()
    return `${sqlName} ${newSqlType}`;
    }).join(',\n');
};
const getSchemaNew = jsonArr => {
  const properties = {};
  const required = jsonArr.filter(pl => pl.props?.includes('requiredSchemaNew')).map(pl => pl.name);
  jsonArr.filter(pl => !pl.props?.includes('noSchema')).forEach(pl => {
    const {name, type, maxLength, minLength} = pl;
    const obj = {type};
    if(maxLength)obj.maxLength=maxLength;
    if(minLength)obj.minLength=minLength;
    properties[name] = {...obj};
  });
  return {required, properties, "additionalProperties": false};
};
const getSchemaUpdate = jsonArr => {
    const newObj = {};
    jsonArr.filter(pl => !pl.props?.includes('noSchema')).forEach(pl => {
    const {name, type, maxLength} = pl;
    const obj = {type};
    if(maxLength)obj.maxLength=maxLength;
    newObj[name] = {...obj}
    });
    const properties = filterFalsy(newObj);
    return {required: [], properties, "additionalProperties": false}
};
const getFormFields = jsonArr => {
    const newObj = {};
    jsonArr.filter(pl => !pl.props?.includes('noForm')).forEach((pl) => {
      // console.log({pl});
      const {name, type, maxLength, minLength, fieldType, label, label2, mainOrder, order, col, initialValue, sort, calculation} = pl;
      const validation = maxLength || minLength ? filterFalsy({maxLength, minLength}) : null;
      const required = !!minLength;
      newObj[name] = filterFalsy({name, type, initialValue, fieldType, label, label2, mainOrder, order, col, required, sort, calculation});
      if(validation)newObj[name].validation = validation;
    });
    return newObj;
};
export const getAllPropertiesFromCsvData = values => {
  const jsonArr = getJsonArr(values);
  const sql = getSql(jsonArr);
  const returnArray = jsonArr.map(pl => pl.name);
  const schemaNew = getSchemaNew(jsonArr);
  const schemaUpdate = getSchemaUpdate(jsonArr);
  const formFields = getFormFields(jsonArr);
  const allProperties = {jsonArr, returnArray, schemaNew, schemaUpdate, formFields, sql};
  // console.log({allProperties});
  return allProperties;
};








const getCalculated = ({fields, data, k}) => {
  // console.log({fields, k, data});
  
  const calculation = fields[k]?.calculation;
  const value = data[k];
  const {numberFlsPa, numberLb} = data;
  // console.log({fields, data, k, calculation, value, numberFlsPa, numberLb})
  if(!calculation)return "";
  if(calculation === "proFLS"){
    // if(!numberFlsPa)return""
    const _fls =  `${
      numberFlsPa ? `${toEuro(value / numberFlsPa / 100)} / FLS` : ""}`
    const _lb =  `${numberLb ? `${toEuro(value / numberLb / 100)} / LB` : ""}`;
    // console.log({_fls, _lb}, !!_lb)
    return `${_fls} ${_fls && _lb ? " - ": ""}${_lb}`
  }
};





const _getArrayFromKeys = (keys, fields, data) => {
  // console.log({keys, fields, data})
  const res = keys.map(k => {
    // console.log({k}, fields[k], data[k]);
    return {
      ...fields[k],
      value:data[k],
      displayedValue: getDisplayedValue(data[k], fields[k]?.fieldType),
      calculated: getCalculated({fields, data, k}),
    }
  });
  return sortArrayByObjectField(res, "sort");
};
const _getReducedOrder = arr => {
  let currentMainOrder = "";
  let currentOrder = "";
  const reduced = arr.map(i => {
      i._mainOrder = i.mainOrder;
      i._order = i.order;
      if(currentMainOrder !== i.mainOrder){
          currentMainOrder = i.mainOrder;
      }else{
          i._mainOrder = ""
      }
      if(currentOrder !== i.order){
          currentOrder = i.order;
      }else{
          i._order = ""
      };
      if(i.order === i.mainOrder)i._order = "";
      return i;
  });
  return reduced;
}

export const getNewPlaceArrays = (place) => {
  // console.log({place});
  
  const fields = getAllPropertiesFromCsvData(places).formFields;

  const exclude = ["id", "locationId", "placeType", "locationType", "companyName", "locationName", "companyType", "createdAt", "createdBy", "updatedAt", 'updatedBy'];
  const notExcludedKeys = Object.keys(place).filter(i => !exclude.includes(i));
  const notNullNotExcludedKeys = notExcludedKeys.filter(i => !!place[i]);
  // console.log('inside getNewPlaceArrays', {place, places, fields, notExcludedKeys});

  const resultNotExcluded = _getArrayFromKeys(notExcludedKeys, fields, place);
  const resultNotNullNotExcluded = _getArrayFromKeys(notNullNotExcludedKeys, fields, place);

  const reducedNotExcluded = _getReducedOrder(resultNotExcluded);
  const reducedNotNullNotExcluded = _getReducedOrder(resultNotNullNotExcluded);

  // console.log({resultNotExcluded, resultNotNullNotExcluded, reducedNotExcluded, reducedNotNullNotExcluded});
  return {resultNotExcluded, resultNotNullNotExcluded, reducedNotExcluded, reducedNotNullNotExcluded};
}
